import React from "react";
export default function Spinner() {
  return (
    <div class="ui container">
      <div class="ui active inverted dimmer">
        <div class="ui text loader">Loading</div>
      </div>
      <p></p>
    </div>
  );
}
